import axios from 'axios';
import config from '../../../../../../core/config/configureSettings';
import { constructServiceURL } from '../../../../../../core/modules/common/tools/URLTools';

const apiFetchDespatchImpcToImpcPerformance = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getDespatchImpcToImpcPerformance',
    stub: config.useStubbedEndpoints,
  });

  return axios.post(serviceURL, payload, {
    cancelToken: payload.token,
  });
};

export default apiFetchDespatchImpcToImpcPerformance;
